// extracted by mini-css-extract-plugin
export default {"movies-list":"MoviesList_movies-list__JWOUW"};